import { mapState, mapActions } from 'pinia'
import { scrollToElement } from 'www/utils'
import {
  APPOINTMENT_ERRORS,
  DELAY_UNTIL_SKELETONS_DISAPPEAR,
  RECURSIVE_INTERVAL_SCHEDULE_CHECKS_DOCTOR_MS,
} from 'www/vue_components/common/AppointmentPage/constants'
import { getIdFromQuery } from 'www/vue_components/common/AppointmentPage/functions'
import {
  useGlobalDataStore,
  useDoctorDataStore,
  useServiceDataStore,
  useCalendarDataStore,
  useAuthorizationStore, // todo(useAuthMt) - удалить
  useAppointmentDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import { LOGIN_LINKS } from 'www/constants/links'

const AppointmentPageErrorData = {
  data() {
    return {
      isVisibleDialog: true,
      storeActions: {
        understandWithReload: {
          buttonSecond: {
            on: { click: this.handleReload },
            text: 'Понятно',
          },
        },
        understand: {
          buttonSecond: {
            on: { click: this.handleUnderstand },
            text: 'Понятно',
          },
        },
        understandWithRedirect: {
          buttonSecond: {
            on: { click: this.handleRedirect },
            text: 'Понятно',
          },
        },
        back: {
          buttonSecond: {
            on: { click: this.handleBack },
            text: 'Назад',
          },
        },
        good: {
          buttonSecond: {
            on: { click: this.handleBack },
            text: 'Хорошо',
          },
        },
        close: {
          buttonSecond: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
        },
        reloadClose: {
          buttonSecond: {
            on: { click: this.handleClose },
            text: 'Обновить',
          },
        },
        reload: {
          buttonSecond: {
            on: { click: this.handleReload },
            text: 'Обновить',
          },
        },
        loginHowPatient: {
          buttonSecond: {
            on: { click: this.handleLogin },
            text: 'Войти',
          },
        },
        toLpuServiceList: {
          buttonSecond: {
            on: { click: this.handleToLpuServiceList },
            text: 'К списку услуг',
          },
        },
        toListLpu: {
          buttonSecond: {
            on: { click: this.handleToListLpu },
            text: 'К списку клиник',
          },
        },
        toListDoctor: {
          buttonSecond: {
            on: { click: this.handleToListDoctor },
            text: 'К списку врачей',
          },
        },
        toDoctor: {
          buttonSecond: {
            on: { click: this.handleToDoctor },
            text: 'К врачу',
          },
        },
        closeAndToListLpu: {
          buttonFirst: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
          buttonSecond: {
            on: { click: this.handleToListLpu },
            text: 'К списку клиник',
          },
        },
        closeAndToLpuServiceList: {
          buttonFirst: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
          buttonSecond: {
            on: { click: this.handleToLpuServiceList },
            text: 'К списку услуг',
          },
        },
        closeAndToDoctor: {
          buttonFirst: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
          buttonSecond: {
            on: { click: this.handleToDoctor },
            text: 'К врачу',
          },
        },
        closeAndReload: {
          buttonFirst: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
          buttonSecond: {
            on: { click: this.handleReload },
            text: 'Обновить',
          },
        },
        closeAndLoginHowPatient: {
          buttonFirst: {
            on: { click: this.handleClose },
            text: 'Закрыть',
          },
          buttonSecond: {
            on: { click: this.handleLogin },
            text: 'Войти как пациент',
          },
        },
        selectOtherSlot: {
          buttonSecond: {
            on: { click: this.handleSelectDate },
            text: 'Выбрать другое время',
          },
        },
        selectOtherLpu: {
          buttonSecond: {
            on: { click: this.handleSelectOtherLpu },
            text: 'Выбрать клинику',
          },
        },
        selectPatientOrOtherLpu: {
          buttonFirst: {
            on: { click: this.handleReload },
            text: 'Выбрать другого пациента',
          },
          buttonSecond: {
            on: { click: this.handleSelectOtherLpu },
            text: 'Выбрать клинику',
          },
        },
        reloadDoctorCalendar: {
          buttonSecond: {
            on: { click: this.handleReloadDoctorCalendar },
            text: 'Обновить',
          },
        },
      },
    }
  },
  watch: {
    isVisibleDialog(val) {
      /**
       * setTimeout используется для того, чтобы обновить errorData.isEnabled после
       * анимации открытия/закрытия диалога, иначе происходит мерцание анимации
       */
      setTimeout(() => {
        this.updateErrorDataIsEnabled(val)
      }, 200)
    },
  },
  computed: {
    currentActions() {
      const buttonStateName = this.errorData.buttonState?.[this.errorData.isDialogRender ? 'post' : 'get']
      const actions = this.storeActions[buttonStateName]
      const actionsDefault = this.errorData.isDialogRender
        ? this.storeActions.understand
        : this.storeActions.back

      return actions || actionsDefault
    },
    ...mapState(useGlobalDataStore, [
      'urls',
      'errorData',
    ]),
    ...mapState(useDoctorDataStore, [
      'doctorData',
      'selectedDoctor',
      'doctorsData',
    ]),
    ...mapState(useAppointmentDataStore, [
      'appointmentObjectTypes',
      'useAuthMt',
    ]),
    ...mapState(useCalendarDataStore, [
      'appointmentCalendarEl',
    ]),
    ...mapState(useCalendarDataStore, [
      'isEmptyCalendarList',
    ]),
    ...mapState(useServiceDataStore, [
      'isSelectedDoctorEquipmentRelation',
    ]),
  },
  methods: {
    handleUnderstand() {
      if (this.errorData.isDialogRender) {
        this.handleClose()
        return
      }

      this.handleBack()
    },
    handleRedirect() {
      window.location.assign(this.errorData.redirectUrl)
    },
    handleClose() {
      this.isVisibleDialog = false
    },
    handleBack() {
      window.history.back()
    },
    handleReload() {
      window.location.reload()
    },
    handleLogin() {
      this.updateErrorDataIsEnabled(false)
      window.location.replace(LOGIN_LINKS.medtochka)
    },
    handleToLpuServiceList() {
      window.location.assign(this.urls.referrerToLpuServiceList)
    },
    handleToListLpu() {
      window.location.assign(this.urls.referrerToLpuList)
    },
    handleToListDoctor() {
      window.location.assign(this.urls.referrerToDoctorList)
    },
    getTargetDoctorPageUrl() {
      const targetDoctorId = getIdFromQuery('targetDoctorId')

      if (!this.appointmentObjectTypes.isServices || targetDoctorId === 'undefined') {
        return ''
      }

      const { pageUrl = '' } = this.doctorsData.find(({ id }) => id === targetDoctorId) || {}

      return pageUrl
    },
    handleToDoctor() {
      const pageUrl = this.getTargetDoctorPageUrl() || this.doctorData.pageUrl

      window.location.assign(pageUrl || document.referrer)
    },
    handleSelectDate() {
      this.handleClose()

      if (this.appointmentObjectTypes.isServices) {
        setTimeout(() => {
          // Если рендерится экран ошибки (при этом раньше формы), то appointmentCalendarEl вернёт null
          if (this.appointmentCalendarEl) {
            scrollToElement(this.appointmentCalendarEl)
          }
        }, DELAY_UNTIL_SKELETONS_DISAPPEAR)

        return
      }

      this.requestForSlots({
        errorRequestCallback: this.showErrorState,
      })

      setTimeout(() => {
        this.startRecursiveUpdateDoctorSchedule()
      }, RECURSIVE_INTERVAL_SCHEDULE_CHECKS_DOCTOR_MS)

      /**
       * setTimeout - нужен для того, чтобы дождаться когда
       * закроется модалка с ошибкой, перед тем как раскрыть календарь
       */
      setTimeout(() => {
        this.updateCalendarIsChanging(true)
        this.resetSelectedDate()

        // Если рендерится экран ошибки (при этом раньше формы), то appointmentCalendarEl вернёт null
        if (this.appointmentCalendarEl) {
          // Необходимо подождать, когда начнётся переход слайдов
          this.$nextTick(() => {
            scrollToElement(this.appointmentCalendarEl)
          })
        }
      }, 200)
    },
    handleSelectOtherLpu() {
      window.location.assign(this.urls.referrerToLpuList)
    },
    handleReloadDoctorCalendar() {
      this.isVisibleDialog = false
      this.updateErrorData({})
      this.startRecursiveUpdateDoctorSchedule()
    },
    showErrorState() {
      this.updateErrorData({
        isDialogRender: true,
        isEnabled: true,
        ...APPOINTMENT_ERRORS.appointmentDateNotAvailable,
      })
    },
    handleClickButtonFirst() {
      this.errorData.buttonFirstCallback()
    },
    handleClickButtonSecond() {
      this.errorData.buttonSecondCallback()
    },
    ...mapActions(useGlobalDataStore, [
      'updateErrorData',
      'updateErrorDataIsEnabled',
    ]),
    ...mapActions(useCalendarDataStore, [
      'updateCalendarIsChanging',
      'resetSelectedDate',
      'requestForSlots',
      'startRecursiveUpdateDoctorSchedule',
    ]),
    ...mapActions(useAuthorizationStore, [ // todo(useAuthMt) - удалить
      'resetUserAuthorization', // todo(useAuthMt) - удалить
    ]),
  },
}

export default AppointmentPageErrorData
